// extracted by mini-css-extract-plugin
export default {"interaction":"Interaction_interaction__X+UXU","down":"Interaction_down__6awkc"};